export enum AdminQuestionnaireTableColumnTitle {
  Name = "Naziv",
  Link = "",
  Options = "",
}
